import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material';

// Roomy rows like the other details pages, just set in smaller type with a hairline rule between.
const ROW_RULE = '1px solid rgba(255, 255, 255, 0.08)';

const LABEL_SX = {
  whiteSpace: 'nowrap',
  color: '#CFCFCF',
  fontSize: '0.75rem',
  pr: 3,
  // A fixed share rather than shrink-to-fit, so every value starts in the same column.
  width: '50%',
  borderBottom: ROW_RULE,
};

const VALUE_SX = {
  wordBreak: 'break-word',
  fontSize: '0.75rem',
  borderBottom: ROW_RULE,
};

// The read-only facts under a details page's cards. Rows are { key, label, value } and an empty
// value is shown as a dash rather than left blank. An action sits in the top right corner, within
// the card's padding, so the rows lay out the same with or without it.
const DetailsTable = ({ rows, action }) => (
  <Box
    sx={theme => ({
      position: 'relative',
      backgroundColor: '#484848',
      boxShadow: '0px 1px 2px 0px #64748B1A',
      borderRadius: theme.spacing(1),
      padding: '32px 24px',
      width: '100%',
    })}>
    {action ? <Box sx={{ position: 'absolute', top: 8, right: 8 }}>{action}</Box> : null}
    <Table>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.key} sx={{ verticalAlign: 'top', '&:last-of-type td': { border: 0 } }}>
            <TableCell sx={LABEL_SX}>{row.label}</TableCell>
            <TableCell sx={VALUE_SX}>
              {row.value === null || row.value === undefined || row.value === '' ? '-' : row.value}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

export default DetailsTable;
